import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteFetchList from './InfiniteFetchList';
import CompanyCard from './CompanyCard';
import UserCard from './UserCard';

export default class DirectoryList extends Component {
  static propTypes = {
    perPage: PropTypes.number.isRequired,
    apiUrl: PropTypes.string.isRequired,
    noResultsMessage: PropTypes.string,
    directoryType: PropTypes.string,
  }

  static defaultProps = {
    noResultsMessage: 'We couldn’t find any companies. Please refine your filters and try again.',
    directoryType: 'Companies',
  }

  constructor(props) {
    super(props);
  }

  // Note: perhaps it would be better to render these in some dynamic fashion, if we ever expand the
  // directory to encompass more types
  renderItem = (item, key) => {
    switch (this.props.directoryType) {
      case 'Users':
        return (<UserCard key={key} {...item} />);
      case 'Companies':
      default:
        return (<CompanyCard key={key} {...item} />);
    }
  }

  render() {
    return (
      <InfiniteFetchList
        apiUrl={this.props.apiUrl}
        perPage={this.props.perPage}
        itemRenderer={this.renderItem}
        noResultsMessage={this.props.noResultsMessage}
      />
    );
  }
}
